var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"App"},[_c('Header'),_c('router-view',{class:_vm.$store.state.isFooterFixed ? 'router-view' : 'is-footer-fixed'}),_c('Footer'),_c('Login')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }